import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DebugState = {
  enabled: boolean;
  estimateGasDisabled: boolean;
  forceOrderRoute: 'aggregator' | 'pool' | undefined;
  marketExecutionForLimitOrderDisabled: boolean;
};

const initialState: DebugState = {
  enabled: false,
  estimateGasDisabled: false,
  marketExecutionForLimitOrderDisabled: false,
  forceOrderRoute: undefined,
};

export const debugSlice = createSlice({
  name: 'debug',
  initialState,
  reducers: {
    toggleDebug(state) {
      state.enabled = !state.enabled;
    },
    setForceOrderRoute(
      state,
      action: PayloadAction<'aggregator' | 'pool' | undefined>,
    ) {
      state.forceOrderRoute = action.payload;
    },
    toggleMarketExecutionForLimitOrderDisabled(state) {
      state.marketExecutionForLimitOrderDisabled =
        !state.marketExecutionForLimitOrderDisabled;
    },
    toggleEstimateGasDisabled(state) {
      state.estimateGasDisabled = !state.estimateGasDisabled;
    },
  },
});

export const debugReducer = debugSlice.reducer;
